import { useState } from "react";

const NAV_ITEMS = [
  { label: "热议广场", href: "#feed" },
  { label: "围观分类", href: "#category" },
  { label: "今日话题", href: "#today" },
  { label: "群众热议", href: "#chatter" },
  { label: "热议FAQ", href: "#faq" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-white">
            <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">
            爆料<span className="text-primary-500">网</span>
          </span>
        </a>

        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
            <span className="relative flex h-2 w-2">
              <span className="anim-pulse absolute inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
            </span>
            38w 人围观中
          </span>
          <a
            href="#submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600"
          >
            我要爆料
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="anim-pop border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-white"
            >
              我要爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}